import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';

/**
 * KPI tile — flagship metric display.
 * Variants: "neutral" | "profit" | "loss" | "warning"
 *
 * Props:
 *   label    — short caption
 *   value    — primary number (string or number)
 *   sub      — optional subline (e.g., "+2.4% vs yesterday")
 *   trend    — "up" | "down" | "flat"  (renders an arrow chip)
 *   icon     — optional <Icon /> for the right-corner glyph
 *   intent   — "neutral" (default) | "profit" | "loss" | "warning"
 */
export default function KPITile({ label, value, sub, trend, icon, intent = 'neutral' }) {
  const TrendIcon = trend === 'up' ? ArrowUpRight : trend === 'down' ? ArrowDownRight : Minus;
  const trendColor =
    trend === 'up'   ? 'var(--profit)' :
    trend === 'down' ? 'var(--loss)'   : 'var(--text-tertiary)';

  return (
    <div className={`kpi-tile kpi-${intent}`}>
      <div className="kpi-label">
        <span>{label}</span>
        {icon && <span className="kpi-icon">{icon}</span>}
      </div>
      <div className="kpi-value">{value}</div>
      {(sub || trend) && (
        <div className="kpi-sub">
          {trend && (
            <span style={{ color: trendColor, display: 'inline-flex', alignItems: 'center' }}>
              <TrendIcon size={14} strokeWidth={2.5} />
            </span>
          )}
          {sub}
        </div>
      )}
    </div>
  );
}
